import { find, startCase, toUpper } from "lodash/fp";

import type { UserDistributionSetting, UserSettings } from "@app/common/types";
import { IntegrationProviderCategory } from "@app/common/types/providerTypes";

export const shouldShowParticipantDisclaimer = (description: string) =>
  description.includes("participants");

export const getCategoryLabel = (
  category: IntegrationProviderCategory
): string => {
  switch (category) {
    case "crm":
      return toUpper(category);
    default:
      return startCase(category);
  }
};

const getRecipientsFromUserDistributionSettings = ({
  userSettings,
  provider,
  category,
}: {
  userSettings: UserSettings;
  provider: UserDistributionSetting["method"];
  category: UserDistributionSetting["category"];
}) => {
  const settingsForProvider = find(
    { method: provider, category },
    userSettings.userDistributionSettings
  );

  if (!settingsForProvider || !settingsForProvider.isEnabled) {
    return "no one";
  }

  return settingsForProvider.sendTo === "me"
    ? "only me"
    : "me and participants* with access";
};

export const getMeetingRecapRecipientsDescriptionFromUserSettings = ({
  userSettings,
  provider,
}: {
  userSettings: UserSettings;
  provider: UserDistributionSetting["method"];
}): string => {
  return getRecipientsFromUserDistributionSettings({
    userSettings,
    provider,
    category: "meeting_report",
  });
};

export const getMeetingPreReadRecipientsDescriptionFromUserSettings = ({
  userSettings,
  provider,
}: {
  userSettings: UserSettings;
  provider: UserDistributionSetting["method"];
}): string => {
  return getRecipientsFromUserDistributionSettings({
    userSettings,
    provider,
    category: "meeting_pre_read",
  });
};

export const getTopicReportRecipientsDescriptionFromUserSettings = ({
  userSettings,
  provider,
}: {
  userSettings: UserSettings;
  provider: UserDistributionSetting["method"];
}): string => {
  return getRecipientsFromUserDistributionSettings({
    userSettings,
    provider,
    category: "topic_summary",
  });
};
